import React from 'react';
import {
  IResourceComponentsProps,
  useDelete,
  useGetIdentity,
  useNavigation,
  useUpdate,
} from '@pankod/refine-core';
import {
  DataGrid,
  GridActionsCellItem,
  GridColumns,
  List,
  Typography,
  useDataGrid,
} from '@pankod/refine-mui';
import Close from '@mui/icons-material/Close';
import Edit from '@mui/icons-material/Edit';
import dayjs from 'dayjs';
import { ADMIN_USERS_RESOURCE } from 'services/adminUserService';
import { CONST } from 'config/const';

export const ManagerList: React.FC<IResourceComponentsProps> = () => {
  const { edit } = useNavigation();
  const { dataGridProps } = useDataGrid<any>({
    initialPageSize: 10,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
  });
  const { mutate: updateAdminUser } = useUpdate();
  // const { mutate: deleteAdminUser } = useDelete();

  const currentUser = useGetIdentity();

  const onToggleStatus = (row: any) => async () => {
    if (row.email === currentUser.data?.email) return;

    const newStatus =
      row.status === CONST.ADMIN_STATUS.INACTIVE
        ? CONST.ADMIN_STATUS.ACTIVE
        : CONST.ADMIN_STATUS.INACTIVE;
    await updateAdminUser({
      resource: ADMIN_USERS_RESOURCE,
      id: row.id,
      values: {
        status: newStatus,
      },
    });
  };

  // const onDelete = (row: any) => async () => {
  //   if (row.email === currentUser.data?.email) return;
  //   await deleteAdminUser({
  //     resource: ADMIN_USERS_RESOURCE,
  //     id: row.id,
  //   });
  // };

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: 'email',
        headerName: 'Email',
        flex: 1,
        minWidth: 160,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'role',
        headerName: 'Role',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'offer_limit',
        headerName: 'Offer Limit',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
        valueFormatter: function valueFormatter({ value }) {
          return value === 0 ? 'Unlimited' : value;
        },
      },
      {
        field: 'created_at',
        headerName: 'Created at',
        flex: 1,
        minWidth: 160,
        disableReorder: true,
        sortable: true,
        renderCell: function render({ row }) {
          return (
            <Typography>
              {dayjs(row.created_at.toDate()).format(
                'YYYY-MM-DD HH:mm:ss',
              )}
            </Typography>
          );
        },
      },
      {
        field: 'updated_at',
        headerName: 'Updated at',
        flex: 1,
        minWidth: 160,
        disableReorder: true,
        sortable: true,
        renderCell: function render({ row }) {
          return (
            <Typography>
              {dayjs(row.updated_at.toDate()).format(
                'YYYY-MM-DD HH:mm:ss',
              )}
            </Typography>
          );
        },
      },
      {
        field: 'actions',
        headerName: '#',
        type: 'actions',
        width: 40,
        getActions: function render({ row }) {
          const disableLabel =
            row.status === CONST.ADMIN_STATUS.INACTIVE
              ? 'Enable'
              : 'Disable';
          return [
            <GridActionsCellItem
              key={1}
              label="Edit"
              icon={<Edit color="success" />}
              onClick={() => edit('admin_users', row.id)}
              showInMenu
            />,
            <GridActionsCellItem
              key={2}
              label={disableLabel}
              icon={<Close color="error" />}
              onClick={onToggleStatus(row)}
              disabled={row.email === currentUser.data?.email}
              showInMenu
            />,
            // <GridActionsCellItem
            //   key={3}
            //   label="Delete"
            //   icon={<Close color="error" />}
            //   onClick={onDelete(row)}
            //   disabled={row.email === currentUser.data?.email}
            //   showInMenu
            // />,
          ];
        },
      },
    ],
    [currentUser.data?.email, edit],
  );

  return (
    <List
      resource={ADMIN_USERS_RESOURCE}
      title="Admin Users"
      createButtonProps={{
        children: <>Create New User</>,
      }}
      canCreate
      cardProps={{ sx: { paddingX: { xs: 0, md: 0 } } }}
    >
      <DataGrid
        {...dataGridProps}
        columns={columns}
        autoHeight
        disableColumnFilter={true}
        disableColumnSelector={true}
        rowsPerPageOptions={[5, 10, 15, 20]}
        density="comfortable"
      />
    </List>
  );
};
